<template>
    <div>
        <a-upload :action="$api.file.uploadFile" listType="picture-card" :beforeUpload="beforeUpload" :fileList="fileList"
            @preview="handlePreview" @change="handleChange">
            <div v-if="fileList.length < maxLimit">
                <a-icon type="plus" />
                <div class="ant-upload-text">Upload</div>
            </div>
        </a-upload>
        <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
            <img alt="example" style="width: 100%" :src="previewImage" />
        </a-modal>
    </div>
</template>
<script >
export default {
    props: {
        maxLimit:{
            type: Number,
            default:1
        },
        images:{
            type: Array,
            default:[]
        }
    },
    data() {
        return {
            fileList: [],
            previewImage: "",
            previewVisible: false,
        }
    },
    mounted() {
        if(this.images){
            this.fileList = this.images;
        }
    },
    methods: {
        beforeUpload(file, fileList) {
            var isJPGPNG = false;
            if (file.type === "image/jpeg" || file.type === "image/png") {
                isJPGPNG = true;
            } else {
                isJPGPNG = false;
                this.$message.error("只能上传jpg/png格式的文件!");
            }
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$message.error("文件不能超过2MB!");
            }
            return isJPGPNG && isLt2M;
        },
        handlePreview(file) {
            this.previewImage = file.url || file.thumbUrl;
            this.previewVisible = true;
        },
        handleChange(info) {
            if (info.file.status) {
                this.fileList = info.fileList;
                this.$emit("getFileList",this.fileList)
            }
        },
        handleCancel() {
            this.previewVisible = false;
        },
    }
}

</script>
<style></style>
